import template from './refineTaskSort.html';
import controller from './RefineTaskSortController';

function refineTaskSort() {
  return {
    restrict: 'E',
    scope: {
      filterSet: '='
    },
    template,
    controller: 'RefineTaskSortController'
  };
}

export default function (ngModule) {
  ngModule.directive('refineTaskSort', refineTaskSort);
  controller(ngModule);
}
